import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import axios from "axios";
import { getAzureJWTToken } from "../../utilities/auraHealthUtils";
import { Typography } from "@mui/material";
import { Section } from "@arp/react-ndbx";
import { getAllOccupationOptions } from "../../hooks/useAuraService";
import { useForm, Controller } from "react-hook-form";
import { useGetQuote } from "../../hooks/dataHooks/useGetQuoteData";
import { AURA_QUESTION } from "../../config/const/enums";
import useSharedData from "../../hooks/useSharedData";
import _ from "lodash";

function AuraOccupationAutoComplete({ mappedContent, control }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [defaultOptionOcp, setdefaultOptionOcp] = useState([]);
  const { data: quoteData, isLoading: quoteIsLoading } = useGetQuote();
  const { accessToken } = useSharedData();

  // const azurAccessToken = getAzureJWTToken();

  const loadOptions = async (inputValue, callback) => {
    if (inputValue?.length < 2) {
      callback([]);
      return;
    }
    try {
      let allOccupationResponse = await getAllOccupationOptions(
        inputValue,
        mappedContent.id,
        accessToken
        // azurAccessToken
      );
      if (allOccupationResponse?.constraints?.choices) {
        // remove the Not in List option from the array
        const filteredOccupationChoices = _.filter(
          allOccupationResponse.constraints.choices,
          (choice) => !choice.text.includes(AURA_QUESTION.AURA_NOT_IN_LIST)
        );
        const options = filteredOccupationChoices.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        callback(options);
        setdefaultOptionOcp(options);
      }
    } catch (error) {
      console.error("Error fetching options:", error);
      callback([]);
    }
  };

  const customStyles = {
    singleValue: (provided) => ({
      ...provided,
      overflow: "visible", // Customize the color of the single value
      textAlign: "left",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor:
        state.isSelected || state.isFocused ? "#f0f0f0" : "transparent", // Set the background color for selected and focused states
      color: state.isSelected || state.isFocused ? "#333" : "#666", // Set the text color for selected and focused states
      maxHeight: "100px", // Set the height of the options to 100px
      display: "flex",
      alignItems: "center",
      lineHeight: "30px !important",
    }),
    menu: (provided) => ({
      ...provided,
      lineHeight: "20px !important",
      //   minHeight: "50px", // Adjust the max-height to fit the options within the desired dimensions
    }),
    control: (provided) => ({
      ...provided,
      borderColor: "#999", // Set the border color for the control
      boxShadow: "none", // Remove the default box shadow
      "&:hover": {
        borderColor: "#999", // Set the border color on hover
      },
      borderTop: "none",
      borderRight: "none",
      borderLeft: "none",
      borderRadius: "0px",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
  };

  return (
    <Section md={7}>
      <Section sx={{ marginBottom: 4 }}>
        <Typography
          sx={{
            width: "fit-content !important",
            marginBottom: 4,
          }}
          variant="label-large-bold"
          dangerouslySetInnerHTML={{ __html: mappedContent.richText }}
        ></Typography>
      </Section>
      <Section md={9}>
        <Controller
          name={AURA_QUESTION.AURA_QUESTION_NAME}
          control={control}
          defaultValue={null}
          render={({ field }) => (
            <AsyncSelect
              cacheOptions
              // isClearable
              defaultOptions={defaultOptionOcp}
              loadOptions={loadOptions}
              styles={customStyles}
              placeholder="Type to filter"
              {...field}
            />
          )}
        />
      </Section>
    </Section>
  );
}

export default AuraOccupationAutoComplete;
